import { render } from "./FileInput.vue?vue&type=template&id=33651afa"
import script from "./FileInput.vue?vue&type=script&lang=js"
export * from "./FileInput.vue?vue&type=script&lang=js"

import "./FileInput.vue?vue&type=style&index=0&id=33651afa&lang=scss"
script.render = render

export default script